import React from 'react';
import { rotas } from '@settings';

export function Navegador(props) {
	const [rota, setRota] = React.useState('');

	const atualizaRota = React.useCallback(() => {
		const { hash } = window.location;
		const rota = Object.keys(rotas).includes(hash) ? hash : '';
		setRota(rota);
	}, []);

	const listener = React.useCallback(() => {
		atualizaRota();
	}, [atualizaRota]);

	React.useEffect(() => {
		atualizaRota();

		window.addEventListener('popstate', listener);

		return () => {
			window.removeEventListener('popstate', listener);
		};
	}, [atualizaRota, listener]);

	const Conteudo = rotas[rota];

	return <Conteudo {...props} />;
}
